const _excluded = ["title", "titleId"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import * as React from "react";
function SvgPrestamoautomotriz(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 413.709 413.709",
    style: {
      enableBackground: "new 0 0 413.709 413.709"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M94.031,232.202c-16.893,0-30.642,13.713-30.706,30.592c0.001,0.039,0.006,0.076,0.006,0.115 c0,0.039-0.005,0.076-0.006,0.115c0.063,16.879,13.813,30.592,30.706,30.592c16.932,0,30.707-13.775,30.707-30.707 C124.738,245.978,110.963,232.202,94.031,232.202z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none"
    },
    points: "188.926,170.831 188.926,120.093 130.959,120.093 101.965,170.831  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none"
    },
    points: "261.78,120.093 212.926,120.093 212.926,170.831 306.718,170.831  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M319.678,232.202c-16.932,0-30.707,13.775-30.707,30.707c0,16.932,13.775,30.707,30.707,30.707 c16.933,0,30.709-13.775,30.709-30.707C350.387,245.978,336.61,232.202,319.678,232.202z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73D0F4"
    },
    d: "M81.287,194.831c-4.277,0-8.231-2.277-10.379-5.977c-2.148-3.699-2.162-8.263-0.041-11.977 l32.449-56.785H64.939L24,186.243v64.666h16.664c5.486-24.41,27.323-42.707,53.367-42.707c26.043,0,47.879,18.297,53.365,42.707 h118.916c5.486-24.41,27.322-42.707,53.365-42.707c26.044,0,47.88,18.297,53.367,42.707h16.664v-46.445l-57.333-9.633H81.287z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3D6889"
    },
    d: "M403.697,182.478l-64.15-10.777l-63.384-71.564c-2.276-2.571-5.547-4.043-8.982-4.043H123.995 H58.254c-4.156,0-8.017,2.15-10.204,5.685L1.796,176.517C0.622,178.413,0,180.601,0,182.831v80.078c0,6.627,5.373,12,12,12h28.664 c5.486,24.41,27.323,42.707,53.367,42.707c26.043,0,47.879-18.297,53.365-42.707h118.916c5.486,24.41,27.322,42.707,53.365,42.707 c26.044,0,47.88-18.297,53.367-42.707h28.664c6.627,0,12-5.373,12-12v-68.598C413.709,188.45,409.477,183.448,403.697,182.478z  M212.926,120.093h48.855l44.938,50.738h-93.792V120.093z M130.959,120.093h57.967v50.738h-86.961L130.959,120.093z  M94.031,293.616c-16.893,0-30.642-13.713-30.706-30.592c0.001-0.039,0.006-0.076,0.006-0.115c0-0.039-0.005-0.076-0.006-0.115 c0.063-16.879,13.813-30.592,30.706-30.592c16.932,0,30.707,13.775,30.707,30.707C124.738,279.841,110.963,293.616,94.031,293.616 z M319.678,293.616c-16.932,0-30.707-13.775-30.707-30.707c0-16.932,13.775-30.707,30.707-30.707 c16.933,0,30.709,13.775,30.709,30.707C350.387,279.841,336.61,293.616,319.678,293.616z M389.709,250.909h-16.664 c-5.487-24.41-27.323-42.707-53.367-42.707c-26.043,0-47.879,18.297-53.365,42.707H147.396 c-5.486-24.41-27.322-42.707-53.365-42.707c-26.044,0-47.881,18.297-53.367,42.707H24v-64.666l40.939-66.15h38.377l-32.449,56.785 c-2.121,3.714-2.107,8.277,0.041,11.977c2.147,3.699,6.102,5.977,10.379,5.977h251.089l57.333,9.633V250.909z"
  }))), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrestamoautomotriz);
export default __webpack_public_path__ + "static/media/PRESTAMOAUTOMOTRIZ.b6669ecdd3da093786f7a90e2f9b96cf.svg";
export { ForwardRef as ReactComponent };